const categoryColors = {
    1: getComputedStyle(document.documentElement).getPropertyValue('--category-1'),
    2: getComputedStyle(document.documentElement).getPropertyValue('--category-2'),
    3: getComputedStyle(document.documentElement).getPropertyValue('--category-3'),
    4: getComputedStyle(document.documentElement).getPropertyValue('--category-4'),
    5: getComputedStyle(document.documentElement).getPropertyValue('--category-5'),
    6: getComputedStyle(document.documentElement).getPropertyValue('--secondary'),
    7: getComputedStyle(document.documentElement).getPropertyValue('--category-6'),
};

 // TODO. WHEN SELECTING sidebar  direct to point
 const SALE_ITEM_TEMPLATE = (data) => `
 <h3>${data.Address}, ${data.Town}</h3>
 <div class="category-pills">
     ${createCategoryPills(data.filter)}
 </div>
 <p class="text-muted">${data.Description || 'No description available'}</p>
 <div class="button-group">
     ${createDirectionsButton(data.Address, data.Town)}
     <button class="select-btn" onclick="selectSale(this)" data-lat="${data.lat}" data-lon="${data.lon}">Select</button>
 </div>
 <hr>
`;

const POPUP_TEMPLATE = (data) => `
    <h3>${data.Address}, ${data.Town}</h3>
    <div class="category-pills">
        ${createCategoryPills(data.filter)}
    </div>
    <p class="text-muted">${data.Description || 'No description available'}</p>
    ${createDirectionsButton(data.Address, data.Town)}
`;
const WILLOW_CREEK_BOUNDS = [
    [50.014401, -113.641767],
    [50.167481, -113.578656]
];

const TOWN_BOUNDS = {
    'Claresholm': [
        [50.0100, -113.5930], // Southwest corner
        [50.0280, -113.5740]// Northeast corner
    ],
    'Stavely': [
        [50.150000, -113.650000],
        [50.170000, -113.630000]
    ],
    // Add more towns as needed
};
  
const map = L.map('map').fitBounds(WILLOW_CREEK_BOUNDS);

L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; <a href="https://jjrondon.netlify.app">Powered by: J.J’S Hub</a>',
    subdomains: 'abcd',
    maxZoom: 20
}).addTo(map);

const categoryLabels = {
    1: "Household Items",
    2: "Antique Items", 
    3: "Clothing",
    4: "Fundraiser",
    5: "Tools",
    6: "Toys",
    7: "Misc"

};

function setupMobileNav() {
    const navToggle = document.getElementById('nav-toggle');
    const navList = document.querySelector('.nav-list');
    const subMenuTriggers = document.querySelectorAll('.has-submenu');

    // Toggle main navigation
    navToggle?.addEventListener('click', () => {
        navToggle.classList.toggle('active');
        navList.classList.toggle('active');
    });

    // Toggle submenus for mobile
    subMenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            if (window.innerWidth <= 799) {
                e.preventDefault();
                const parentLi = this.parentElement;
                // Close other open submenus
                document.querySelectorAll('.nav-list li.submenu-open').forEach(li => {
                    if (li !== parentLi) li.classList.remove('submenu-open');
                });
                parentLi.classList.toggle('submenu-open');
            }
        });
    });
}


function setupDropdowns() {
    const dropdownLinks = document.querySelectorAll('nav ul li a:not(:only-child)');

    dropdownLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const dropdown = this.parentElement.querySelector('.nav-dropdown');

            // Close other dropdowns
            document.querySelectorAll('.nav-dropdown').forEach(drop => {
                if (drop !== dropdown) {
                    drop.classList.remove('active');
                }
            });

            dropdown.classList.toggle('active');
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (e) {
        const isDropdown = e.target.closest('nav ul li a:not(:only-child)');
        if (!isDropdown) {
            document.querySelectorAll('.nav-dropdown').forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }
    });
}


function createDirectionsButton(address, town) {
    const encodedAddress = encodeURIComponent(address);
    const encodedTown    = encodeURIComponent(`${town} AB`);
    

    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}%20${encodedTown}`
    // Check if iOS or Safari
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        return `<a href="maps://maps.apple.com/?q=${encodedAddress}%20${encodedTown}" class="directions-btn">Get Directions</a>`;
    }
    return `<a href="${mapsUrl}" target="_blank" class="directions-btn">Get Directions</a>`;
}

function createCategoryPills(categories) {
    return JSON.parse(categories.replace(/'/g, '"'))
        .map(cat => `<span class="category-pill" style="background-color: ${categoryColors[cat]}">${categoryLabels[cat]}</span>`)
        .join('');
}

function showAllSales() {
    const activeList = document.getElementById('active-sales');
    activeList.innerHTML = '';
    
    markers.forEach(({data}) => {
        const saleDiv = document.createElement('div');
        saleDiv.classList.add('sale-item');
        saleDiv.innerHTML = SALE_ITEM_TEMPLATE(data);
        activeList.appendChild(saleDiv);
    });
}

function showSingleSale(saleData) {
    const activeList = document.getElementById('active-sales');
    activeList.innerHTML = '';
    
    const saleDiv = document.createElement('div');
    saleDiv.innerHTML = SALE_ITEM_TEMPLATE(saleData);
    activeList.appendChild(saleDiv);
}

map.on('click', function(e) {
    if (e.originalEvent.target.classList.contains('leaflet-container')) {
        map.fitBounds(WILLOW_CREEK_BOUNDS);
        showAllSales();
        document.getElementById('category-filter').value = 'all';
    }
});

let markers = [];
let towns = new Set(); // Store unique towns
let currentTown = 'all'; // Track current town filter

function createTownPills(towns) {
    const townFilter = document.createElement('div');
    townFilter.className = 'town-pills';
    townFilter.innerHTML = `
        <span class="town-pill active" data-town="all">All Towns</span>
        ${Array.from(towns).map(town => 
            `<span class="town-pill" data-town="${town}">${town}</span>`
        ).join('')}
    `;
    return townFilter;
}


fetch('/data/garage.csv')
    .then(response => response.text())
    .then(csvText => {
        Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            complete: function(results) {
                // Extract unique towns
                results.data.forEach(row => {
                    if (row.Town) towns.add(row.Town);
                });

                // Add town filter pills
                const townFilter = createTownPills(towns);
                document.getElementById('town-filter').appendChild(townFilter);

                // Add town pill click handlers
                document.querySelectorAll('.town-pill').forEach(pill => {
                    pill.addEventListener('click', function() {
                        document.querySelectorAll('.town-pill').forEach(p => p.classList.remove('active'));
                        this.classList.add('active');
                        currentTown = this.dataset.town;
                        
                        // Zoom to town bounds
                        if (currentTown !== 'all') {
                    
                            if (TOWN_BOUNDS[currentTown]) {
                                map.fitBounds(TOWN_BOUNDS[currentTown]);
                            }
                        } else {
                            map.fitBounds(WILLOW_CREEK_BOUNDS);
                            
                        }
                        
                        updateActiveSales(document.getElementById('category-filter').value);
                    });
                });

                // Update marker creation and data storage
                results.data.forEach(row => {
                    if (row.lat && row.lon) {
                        const filters = JSON.parse(row.filter.replace(/'/g, '"'));
                        
                        const marker = L.circleMarker([parseFloat(row.lat), parseFloat(row.lon)], {
                            radius: 8,
                            fillColor: '#dd2727',
                            color: '#dd2727',
                            weight: 1,
                            opacity: 1,
                            fillOpacity: 0.7
                        })
                        .addTo(map).bindPopup(POPUP_TEMPLATE(row));

                        marker.on('popupclose', function(e) {
                            showAllSales();
                        });

                        markers.push({
                            marker: marker,
                            filters: filters,
                            data: row,
                            town: row.Town
                        });

                        marker.on('click', function(e) {
                            map.setView(e.target.getLatLng(), 15);
                            showSingleSale(row);
                        });
                    }
                });
                
                // Update filter function to include town
                function updateActiveSales(filter) {
                    const activeList = document.getElementById('active-sales');
                    activeList.innerHTML = '';
                    
                    markers.forEach(({data, filters, town}) => {
                        if ((filter === 'all' || filters.includes(parseInt(filter))) &&
                            (currentTown === 'all' || town === currentTown)) {
                            const saleDiv = document.createElement('div');
                            saleDiv.innerHTML = SALE_ITEM_TEMPLATE(data);
                            activeList.appendChild(saleDiv);
                        }
                    });
                }

                // Initialize with all sales
                showAllSales();
            }
        });
    });

    function selectSale(button) {
        const lat = parseFloat(button.dataset.lat);
        const lon = parseFloat(button.dataset.lon);
        
        // Zoom to location
        map.setView([lat, lon], 15);
        
        // Find selected marker
        const selectedMarkerObj = markers.find(m => 
            parseFloat(m.data.lat) === lat && 
            parseFloat(m.data.lon) === lon
        );
        
        if (selectedMarkerObj) {
            // Reset all markers
            markers.forEach(({marker}) => {
                marker.setStyle({
                    fillColor: '#dd2727',
                    color: '#dd2727',
                    opacity: 0.2,
                    fillOpacity: 0.7
                });
            });
            
            // Highlight selected
            selectedMarkerObj.marker.setStyle({
                fillColor: '#dd2727',
                color: '#dd2727',
                opacity: 1,
                fillOpacity: 0.7
            });
            
            // Update sidebar and popup
            showSingleSale(selectedMarkerObj.data);
            selectedMarkerObj.marker.openPopup();
        }
    }

document.getElementById('category-filter').addEventListener('change', function(e) {
        const selectedFilter = this.value;
        
        if (selectedFilter === 'all') {
            map.fitBounds(WILLOW_CREEK_BOUNDS);
            markers.forEach(({marker}) => {
                marker.setStyle({
                    fillColor: '#dd2727',
                    color: '#dd2727',
                    opacity: 1,
                    fillOpacity: 0.7
                });
            });
        } else {
            markers.forEach(({marker, filters}) => {
                if (filters.includes(parseInt(selectedFilter))) {
                    marker.setStyle({
                        fillColor: categoryColors[selectedFilter],
                        color: categoryColors[selectedFilter],
                        opacity: 1,
                        fillOpacity: 0.7
                    });
                } else {
                    marker.setStyle({
                        fillColor: '#dd2727',
                        color: '#dd2727',
                        opacity: 0.2,
                        fillOpacity: 0.05
                    });
                }
            });
        }
        
        updateActiveSales(selectedFilter);
    });

    function updateActiveSales(filter) {
        const activeList = document.getElementById('active-sales');
        activeList.innerHTML = '';
        
        markers.forEach(({data, filters, town}) => {
            if ((filter === 'all' || filters.includes(parseInt(filter))) &&
                (currentTown === 'all' || town === currentTown)) {
                const saleDiv = document.createElement('div');
                saleDiv.innerHTML = SALE_ITEM_TEMPLATE(data);
                activeList.appendChild(saleDiv);
            }
        });
    }

function setupInstructionsModal() {
        const modal = document.getElementById('instructions-modal');
        const helpBtn = document.querySelector('.help-icon');
        const closeBtn = document.querySelector('.close-button');
    
        // Show modal on page load
        window.addEventListener('DOMContentLoaded', () => {
            modal.style.display = 'block';
        });
    
        helpBtn.addEventListener('click', () => {
            modal.style.display = 'block';
        });
    
        closeBtn.addEventListener('click', () => {
            modal.style.display = 'none';
        });
    
        window.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.style.display = 'none';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        setupMobileNav();
        setupInstructionsModal();
    });